const PHONE_OK = /^((8|\+7)[\s-]?)?(\(?\d{3}\)?[\s-]?)?[\d\s-]{7,10}$/

export function getNameError(value: string, touched: boolean): string | null {
    if (!touched) return null
    if (value.length === 0) return 'Укажите имя.'
    const t = value.trim()
    if (t.length < 3) return 'Имя — не меньше 3 символов.'
    if (t.length > 12) return 'Имя — не больше 12 символов.'
    return null
}

export function getPhoneError(value: string, touched: boolean): string | null {
    if (!touched) return null
    if (value.length > 6 && !PHONE_OK.test(value)) return 'Проверьте формат номера.'
    return null
}
